const image_sizes = [
  {name: "gmail.png", width: "90", height: "25"},
  {name: "cronofy.png", width: "97", height: "25"},
  {name: "slack.png", width: "90", height: "23"},
  {name: "zoom.png", width: "92", height: "26"},
  {name: "crome.png", width: "95", height: "26"},
  {name: "adzuna.png", width: "97", height: "25"},
  {name: "indeed.png", width: "85", height: "22"},
  {name: "trovit.png", width: "55", height: "19"},
  {name: "jobble.png", width: "42", height: "32"},
  {name: "total_jobs.png", width: "90", height: "20"},
  {name: "career_jet.png", width: "91", height: "15"},
  {name: "career_global.png", width: "97", height: "25"},
  {name: "job_inventory.png", width: "93", height: "28"},
  {name: "euro_jobs.png", width: "102", height: "41"},
  {name: "jobs_rapido.png", width: "93", height: "22"},
  {name: "google_for_jobs.png", width: "72", height: "37"},
  {name: "cvl_blue.png", width: "79", height: "30"},
  {name: "google_meet.png", width: "98", height: "18"},
  {name: "ms_teams.png", width: "96", height: "36"},
  {name: "ikm_tech_test.png", width: "62", height: "34"},
  {name: "microsoft.png", width: "97", height: "25"},
  {name: "linkedin_feed_post.png", width: "97", height: "25"},
  {name: "twitter.png", width: "36", height: "30"},
  {name: "facebook.png", width: "39", height: "40"},
]

export function imageSize(name){
  const hash  = image_sizes.filter(x => x.name == `${name}.png`)[0] || {name: `${name}.png`, width: "87", height: "35"}
  return hash
}